/* src/app/modules/search/components/doc-view/components/avatar/avatar.component.scss */
.avatar {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  font-size: 0.9rem;
  text-transform: uppercase;
}
/*# sourceMappingURL=avatar.component.css.map */
